import React from 'react';
import { Form, Stack } from 'react-bootstrap';
import { AnnSnapshotItem } from './AnnSnapshotItem.js';
import { useTranslation } from 'react-i18next';
import { ShxHelpText } from '../../../common/ShxHelpText.js';
import {
  useGetAnnouncementSnapshotQuery,
  useMarkAllAnnouncementsReadMutation,
  useUserSetting,
} from '@soulhx/client-store';
import { SHXCol, SHXRow, StandardButton } from '@soulhx/ui-common';
import { AnnouncementTypeIcon } from '../../../comms/announcements/AnnouncementTypeIcon.js';

export const AnnouncementSnapshot = () => {
  const {
    settingValue: showOnHome,
    update: updateShowOnHome,
    isLoading: showOnHomeLoading,
  } = useUserSetting<boolean>('generalShowAnnouncementsOnHome');
  const { t } = useTranslation(['comms', 'translation']);
  const { data } = useGetAnnouncementSnapshotQuery({});
  const [markAllRead] = useMarkAllAnnouncementsReadMutation();

  if (!data || data.length < 1 || !showOnHome || showOnHomeLoading) return null;

  return (
    <SHXCol grow={1} minWidth="400px" className="bg-light-subtle p-1">
      <h5>{t('comms:announcements.title')}</h5>

      <ShxHelpText pageName="comms" textName="announcementsMain" />

      <StandardButton type="complete" variant="success" onClick={() => markAllRead()}>
        {t('comms:announcements.markAllReadBtn')}
      </StandardButton>

      <Stack gap={2}>
        {data.map((ann) => (
          <SHXRow className="p-0 m-0" key={`snapshot-${ann.id}`}>
            <SHXCol style={{ flex: '0 0 auto' }} className="me-1">
              <AnnouncementTypeIcon type={ann.type} />
            </SHXCol>
            <SHXCol>
              <AnnSnapshotItem announcement={ann} />
            </SHXCol>
          </SHXRow>
        ))}
      </Stack>

      <Form.Group className="mt-4 small">
        <Form.Check
          type="switch"
          checked={showOnHome}
          label={t('translation:settings.showAnnouncementsOnHomeScreen')}
          onChange={() => updateShowOnHome(!showOnHome)}
        />
      </Form.Group>
    </SHXCol>
  );
};
